// Mister Gift perf : les scripts du personnaliseur Teeinblue ne tournent que sur les fiches produit
// (le chargeur d'aperçus du panier, plus bas, reste actif partout).
const MG_IS_PRODUCT_PAGE = document.body
  ? document.body.classList.contains("product-template")
  : location.pathname.indexOf("/products/") !== -1;

// Fix tee in blue select
let selectedSize = "30x20 cm"; // Default size

// Function to log events
function logEvent(message) {
  // console.log(`[Size Selection]: ${message}`);
}

// Function to handle size selection
function handleSizeSelection(event) {
  selectedSize = event.target.value;
  logEvent(`Size selected: ${selectedSize}`);
}

// Function to select size after format change
function selectSize(size) {
  const sizeInputs = document.querySelectorAll(
    '.tee-option--size input[type="radio"]'
  );
  logEvent(`Attempting to select size: ${size}`);

  sizeInputs.forEach((input) => {
    if (input.value === size) {
      // Simulate click instead of just setting checked
      input.click();
      logEvent(`Successfully clicked size: ${size}`);
    }
  });
}

// Function to handle format changes
function handleFormatChange() {
  logEvent("Format changed");

  // Wait for DOM to update
  setTimeout(() => {
    selectSize(selectedSize);
  }, 100);
}

// Function to initialize event listeners
function initializeEventListeners() {
  logEvent("Initializing event listeners");

  // Listen for format changes
  document.addEventListener("change", (event) => {
    if (event.target.name === "availableProduct") {
      handleFormatChange();
    }
  });

  // Listen for size changes
  document.addEventListener("change", (event) => {
    if (event.target.name.startsWith("size-")) {
      handleSizeSelection(event);
    }
  });
}

// Initialize when DOM is ready
if (MG_IS_PRODUCT_PAGE) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeEventListeners);
  } else {
    initializeEventListeners();
  }
}

// Optional: Monitor DOM changes for dynamically added elements
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      logEvent("DOM changed - checking for new elements");
      selectSize(selectedSize);
    }
  });
});

/*observer.observe(document.body, {
  childList: true,
  subtree: true,
});*/


// Teeinblue preview loader (no spinner)
(function () {
  const PREVIEW_SELECTOR = '[data-tee-preview]';
  const MAX_ATTEMPTS = 8;
  const RETRY_DELAY = 1200; // ms

  const withCacheBuster = (url, attempt) =>
    `${url}${url.includes('?') ? '&' : '?'}preview=${attempt}-${Date.now()}`;

  const stripResponsiveAttrs = (img) => {
    if (img.dataset.teeResponsiveStripped === 'true') return;

    ['srcset', 'sizes', 'data-widths', 'data-sizes', 'data-src'].forEach((attr) => {
      if (!img.hasAttribute(attr)) return;

      const dataKey = `teeOriginal${attr.replace(/(^[a-z])|(-[a-z])/g, (match) =>
        match.replace('-', '').toUpperCase()
      )}`;

      img.dataset[dataKey] = img.getAttribute(attr);
      img.removeAttribute(attr);
    });

    img.dataset.teeResponsiveStripped = 'true';
  };

  const finish = (img) => {
    img.classList.remove('tee-preview-loading');
    img.dataset.previewState = 'ready';
  };

  const alreadyHasPreview = (img) => {
    const previewUrl = img.dataset.teePreview;
    if (!previewUrl) return true;

    if (img.dataset.previewState === 'ready') return true;
    if (img.dataset.teePreviewLoaded === 'true') return true;

    const current = (img.currentSrc || img.src || '').split('?')[0];
    if (current && current.includes(previewUrl)) {
      img.dataset.teePreviewLoaded = 'true';
      img.dataset.previewState = 'ready';
      return true;
    }

    return false;
  };

  const pollPreview = (img, attempt = 0) => {
    const previewUrl = img.dataset.teePreview;
    if (!previewUrl) {
      finish(img);
      return;
    }

    // stop if we’re no longer loading
    if (img.dataset.previewState !== 'loading') return;
    if (attempt >= MAX_ATTEMPTS) {
      finish(img);
      return;
    }

    stripResponsiveAttrs(img);

    const tester = new Image();
    const src = withCacheBuster(previewUrl, attempt);

    tester.onload = () => {
      img.src = src;
      img.dataset.teePreviewLoaded = 'true';
      finish(img);
    };

    tester.onerror = () => {
      const nextAttempt = attempt + 1;
      setTimeout(() => pollPreview(img, nextAttempt), RETRY_DELAY);
    };

    tester.src = src;
  };

  const hydrateOne = (img) => {
    if (!img || img.dataset.previewInit === 'true') return;
    img.dataset.previewInit = 'true';

    if (!img.dataset.teePreview || alreadyHasPreview(img)) {
      finish(img);
      return;
    }

    img.dataset.previewState = 'loading';
    img.classList.add('tee-preview-loading');
    pollPreview(img, 0);
  };

  const hydrate = (root = document) => {
    if (root.matches?.(PREVIEW_SELECTOR)) hydrateOne(root);
    root.querySelectorAll?.(PREVIEW_SELECTOR).forEach(hydrateOne);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrate());
  } else {
    hydrate();
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) hydrate(node);
      });
    });
  });

  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();


// Safely add enterkeyhint="enter" to dynamic inputs
(function () {
  if (!MG_IS_PRODUCT_PAGE) return;
  const selector = '.tee-scrabble-wrapper .tee__input';

  function applyHint(el) {
    if (!el || el.nodeType !== 1) return; // 1 = ELEMENT_NODE
    if (!el.hasAttribute('enterkeyhint')) el.setAttribute('enterkeyhint', 'enter');
  }

  function scan(root) {
    if (!root) return;
    if (root.matches?.(selector)) applyHint(root);
    root.querySelectorAll?.(selector).forEach(applyHint);
  }

  function start(target) {
    // Initial pass
    scan(document);

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          scan(node);
        }
      }
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  // Ensure we have a Node to observe
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () =>
      start(document.body || document.documentElement)
    );
  } else {
    start(document.body || document.documentElement);
  }
})();



/*document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const container = document.querySelector(".tee-photo-action");

    if (container && !container.querySelector(".giftcard-hint")) {
      const hint = document.createElement("div");
      hint.className = "giftcard-hint";
      hint.innerHTML = `
        <strong>Pas de photos ?</strong>
        <a href="/products/carte-cadeau-mistergift">Offrez une carte cadeau →</a>
        <br>
      `;

      container.appendChild(hint);
      observer.disconnect(); // stop once added
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});*/


// AR

(function () {
  if (!MG_IS_PRODUCT_PAGE) return;
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  function randomString(length = 7) {
    return Array.from({ length }, () =>
      chars[Math.floor(Math.random() * chars.length)]
    ).join("");
  }

  const url = "https://ar.mistergift.fr/s/" + randomString(7);
  let done = false;

  function forceSetValue(input) {
    if (input.value === url) return;

    input.value = url;
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function tryInsert() {
    const input = document.querySelector(
      ".ar-qrcode input.tee__input--text"
    );
    if (!input) return;

    forceSetValue(input);

    // Watch THIS input in case framework wipes it
    const valueWatcher = new MutationObserver(() => {
      forceSetValue(input);
    });

    valueWatcher.observe(input, {
      attributes: true,
      attributeFilter: ["value"],
    });

    // Stop after value stays stable for 2 seconds
    setTimeout(() => {
      done = true;
      valueWatcher.disconnect();
      globalObserver.disconnect();
    }, 2000);
  }

  const globalObserver = new MutationObserver(() => {
    if (!done) tryInsert();
  });

  globalObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // Also try periodically (covers lazy mount cases)
  const interval = setInterval(() => {
    if (done) {
      clearInterval(interval);
    } else {
      tryInsert();
    }
  }, 300);
})();



(function () {
  if (!MG_IS_PRODUCT_PAGE) return;
  const VIDEO_URL = "https://cdn.shopify.com/videos/c/o/v/cd0cd44346a2439bbc5b8f7d2e9df7be.mp4"; // <-- your vertical video URL

  function createPopup() {
    const overlay = document.createElement("div");
    overlay.className = "ar-video-overlay";
    overlay.innerHTML = `
      <div class="ar-video-modal">
        <video class="ar-video-player" src="${VIDEO_URL}" controls autoplay playsinline></video>
        <button class="ar-video-close-circle" aria-label="Fermer">&times;</button>
      </div>
    `;
    document.body.appendChild(overlay);

    overlay.querySelector(".ar-video-close-circle").onclick = () => overlay.remove();
    overlay.onclick = (e) => {
      if (e.target === overlay) overlay.remove();
    };
  }

  function injectLink(target) {
    if (target.querySelector(".ar-video-link")) return;

    const link = document.createElement("div");
    link.className = "ar-video-link";
    link.textContent = "Voir comment ça marche";
    link.onclick = createPopup;

    target.appendChild(link);
  }

  function tryInject() {
    const arInput = document.querySelector(".ar-input");
    if (arInput) injectLink(arInput);
  }

  const observer = new MutationObserver(tryInject);
  observer.observe(document.body, { childList: true, subtree: true });
  tryInject();

  // Styles
  const style = document.createElement("style");
  style.innerHTML = `
    .ar-video-link {
      margin-top: 14px;
      font-weight: 600;
      text-decoration: underline;
      cursor: pointer;
      display: inline-block;
    }

    .ar-video-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: calc(env(safe-area-inset-top) + 12px);
      padding-bottom: calc(env(safe-area-inset-bottom) + 12px);
      z-index: 9999;
    }

    .ar-video-modal {
      position: relative;
      background: #000;
      border-radius: 16px;
      padding: 0;
      max-height: 90vh;
      max-width: 92vw;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

    .ar-video-player {
      height: 70vh; /* smaller so close button sits on top corner */
      width: auto;
      border-radius: 12px;
      display: block;
    }

    .ar-video-modal > .ar-video-close-circle {
      position: absolute !important;
      top: 8px !important;
      right: 8px !important;
      width: 36px !important;
      height: 36px !important;
      border-radius: 50% !important;
      border: none !important;
      background: white !important;
      color: black !important;
      font-size: 24px !important;
      line-height: 36px !important;
      text-align: center !important;
      cursor: pointer !important;
      box-shadow: 0 3px 10px rgba(0,0,0,0.25) !important;
      padding: 0 !important;
      z-index: 2 !important; /* ensures button is above video */
    }
  `;
  document.head.appendChild(style);
})();


(function () {
  if (!MG_IS_PRODUCT_PAGE) return;
  const variantConfig = {}; // { "Cadre noir": "https://...jpg", ... }
  const SEL_ORIGINAL = '.tee-variants:not(.custom-bottom-selector)';
  const SEL_CLONE = '.custom-bottom-selector';

  const getOriginal = () => document.querySelector(SEL_ORIGINAL);
  const getClone = () => document.querySelector(SEL_CLONE);

  // Empreinte des options : si elle change, l'original a été re-rendu par Vue
  const signature = (el) =>
    Array.from(el.querySelectorAll('input')).map(i => i.name + '=' + i.value).join('|');

  function sync() {
    const original = getOriginal(), clone = getClone();
    if (!original || !clone) return;
    const o = original.querySelectorAll('.tee-radio');
    const c = clone.querySelectorAll('.tee-radio');
    if (o.length !== c.length) return;
    o.forEach((r, i) => c[i].classList.toggle('active', r.classList.contains('active')));
  }

  function build() {
    const original = getOriginal();
    const target = document.querySelector('#teeFormInputs');
    if (!original || !target) return;

    const existing = getClone();
    if (existing) {
      if (existing.isConnected && existing.dataset.signature === signature(original)) {
        sync();
        return;
      }
      existing.remove(); // original re-rendu → on reconstruit
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'tee-block tee-field tee-variants tee-variants--outline tee-variants--rounded custom-bottom-selector';
    wrapper.style.marginTop = '20px';
    wrapper.dataset.signature = signature(original);

    original.querySelectorAll('.tee-option').forEach((group, groupIndex) => {
      const clonedGroup = group.cloneNode(true);

      clonedGroup.querySelectorAll('.tee-radio').forEach((radio) => {
        const input = radio.querySelector('input');
        const label = radio.querySelector('label');
        const value = input.value;

        input.id = 'bottom-' + input.id;
        input.name = input.name + '-bottom';
        label.setAttribute('for', input.id);

        if (variantConfig[value]) {
          const img = document.createElement('img');
          img.src = variantConfig[value];
          img.className = 'custom-variant-img';
          img.style.cssText = 'display:block;width:100%;max-width:80px;margin:0 auto 8px;border-radius:4px;';
          label.prepend(img);
          label.style.cssText += 'display:flex;flex-direction:column;height:auto;padding:10px;';
        }

        radio.addEventListener('click', (e) => {
          e.preventDefault();
          // On retrouve l'input ORIGINAL vivant au moment du clic
          const live = getOriginal();
          if (!live) return;
          const liveGroup = live.querySelectorAll('.tee-option')[groupIndex];
          const liveInput = liveGroup &&
            Array.from(liveGroup.querySelectorAll('input')).find(i => i.value === value);
          if (liveInput) liveInput.click(); // Vue met à jour → l'observer resynchronise
        });
      });

      wrapper.appendChild(clonedGroup);
    });

    target.appendChild(wrapper);
    sync();
  }

  const observer = new MutationObserver((mutations) => {
    // Ignore les mutations qui viennent uniquement de notre clone (évite les boucles)
    const external = mutations.some(m => !m.target.closest || !m.target.closest(SEL_CLONE));
    if (external) build();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  build();
})();